import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-card',
  standalone: false,
  templateUrl: './card.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './card.component.scss',
})
export class CardComponent {
  @Input() title!: string;
  @Input() subtitle!: string;
  @Input() width: string = 'auto';
  @Input() height: string = 'auto';
}
